import type { SerializedError } from '@reduxjs/toolkit';
import type { ModalProps } from 'antd';
import { Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { Button } from '@shared/components';
import { useUpdatePersonalUserProfileMutation } from '@shared/services/personalHealth';

import { showErrorModal } from '../utils';

interface Props extends ModalProps {
  displayName?: string;
  memberPrn?: string;
  onClose: () => void;
}

const CareRecipientUpdateConsentModal = ({ displayName, memberPrn, onClose, ...rest }: Props) => {
  const { t } = useTranslation();
  const [updatePersonalUserProfile, { isLoading: isLoadingUpdatePersonalUserProfile }] =
    useUpdatePersonalUserProfileMutation();

  const onConfirm = async () => {
    try {
      await updatePersonalUserProfile({
        PrnTurnOfUpdateHealthRecordFlag: memberPrn,
      }).unwrap();
      onClose();
    } catch (err) {
      const error = err as SerializedError;
      showErrorModal({
        content: error.message,
        errorCode: error.code,
      });
    }
  };

  return (
    <Modal centered closable={false} footer={null} {...rest}>
      <div className="flex flex-col text-center">
        <Typography.Text className="mb-2 text-base font-bold">Access Updated</Typography.Text>
        <Typography.Text className="text-theme-700">
          Your care recipient <strong>({displayName})</strong> has updated your access to his/her health records.
        </Typography.Text>
        <Button
          className="json-checked mt-4 w-full self-center"
          loading={isLoadingUpdatePersonalUserProfile}
          onClick={onConfirm}
        >
          {t('button.ok')}
        </Button>
      </div>
    </Modal>
  );
};

export default CareRecipientUpdateConsentModal;
